import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/styles.scss';export default {
  "projectStatusesList": "_projectStatusesList_pokgt_1",
  "heading": "_heading_pokgt_5",
  "title": "_title_pokgt_9",
  "subTitle": "_subTitle_pokgt_15",
  "statuses": "_statuses_pokgt_20",
  "lastStatus": "_lastStatus_pokgt_24"
};